export default "/images/04b6cef2b704cd22d6f31658ce1da052.jpg";